import Vue from 'vue';
import ActionButton from '@/components/action_button/Index.vue';
import { DIY } from '@/helpers/constants/Store';
import { createNamespacedHelpers } from 'vuex';
import '@/assets/stylesheets/components/_confirmation-dialog.scss';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
const { mapGetters, mapMutations } = createNamespacedHelpers(DIY);
export default Vue.extend({
    mixins: [ViewportSizeMixin],
    computed: {
        ...mapGetters(['toggleConfirmation']),
    },
    methods: {
        ...mapMutations(['hideConfirmation']),
    },
    render(createElement) {
        const self = this;
        return createElement('v-dialog', {
            props: {
                persistent: true,
                value: this.toggleConfirmation,
                width: 400,
            },
        }, [
            createElement('v-card', { class: 'confirmation-dialog' }, [
                createElement('v-card-title', { class: 'text-xs-center title' }, [
                    'Are you sure you want to leave this page?',
                ]),
                createElement('div', { class: 'content' }, [
                    createElement('v-card-text', { class: 'message' }, [
                        'Your In-App Store will not be published.',
                    ]),
                ]),
                createElement('v-card-actions', { class: 'actions' }, [
                    createElement('v-layout', [
                        createElement('v-flex', { class: 'text-xs-center' }, [
                            createElement(ActionButton, {
                                class: {
                                    'button -width -orange-theme': self.smAndUp,
                                    '-small -orange-theme': self.xsOnly,
                                },
                                props: {
                                    id: 'confirm',
                                },
                                on: {
                                    wasClicked: () => {
                                        this.$emit('confirm');
                                    },
                                },
                            }, ['Confirm']),
                            createElement(ActionButton, {
                                props: {
                                    smBtn: self.xsOnly,
                                    cancel: true,
                                    id: 'cancel',
                                },
                                on: {
                                    wasClicked: this.hideConfirmation,
                                },
                            }, ['Cancel']),
                        ]),
                    ]),
                ]),
            ]),
        ]);
    },
});
